import PostcardContainer from './svelte-comps/PostcardContainer.svelte';
import VideoContainer from './svelte-comps/VideoContainer.svelte';

export default (() => {
  jQuery(function() {
    if (document.getElementById('svelte-video-target')) {
      const videoData = document.getElementById('svelte-video-target').dataset.videos;
      const app = new VideoContainer({
        target: document.getElementById('svelte-video-target'),
        props: {
          'videos64': document.getElementById('svelte-video-target').dataset.videos,
          'categories64': document.getElementById('svelte-video-target').dataset.categories,
          'show_pagination': document.getElementById('svelte-video-target').dataset.show_pagination == 'true',
          'show_search': document.getElementById('svelte-video-target').dataset.show_search == 'true',
          'show_categories': document.getElementById('svelte-video-target').dataset.show_categories == 'true',
        }
      })
    }
  });

  jQuery(function() {
    if (document.getElementById('svelte-postcard-target')) {
      const app = new PostcardContainer({
        target: document.getElementById('svelte-postcard-target')
      })
    }
  });

  // other svelte comps here
})()
